import tests from '~/resources/ab/config'

export default defineNuxtRouteMiddleware(() => {
  if (!import.meta.server) return

  useAB().init(tests)
})
